<template>
    <div class="screen-container" >
        <header class="screen-header">
            <div></div>
            <span class="logo">
                <img src="/static/tp/logo.png" alt="" />
            </span>
            <span class="title">智慧供暖管理系统</span>
            <div class="title-right">
                <img src="/static/tp/sj.png" alt="" class="qiehuan" />
                <span class="datetime">{{ formattedTime }}</span>
            </div>
        </header>
        <div class="screen-body">
            <section class="screen-middle">
                <div id="middle-top">
                    <!-- <div id="middle-top1"> -->
                    <div id="middle-top-1">
                        <dial ></dial>
                    </div>
                    <div id="middle-top-1">
                        <dial></dial>
                    </div>
                    <div id="middle-top-1">
                        <dial></dial>
                    </div>
                </div>
                <div id="middle-zj">
                    <div id="middle-zj-1">
                        <allEnvironments :time="formattedTime"></allEnvironments>
                    </div>
                    <div id="middle-zj-1">
                        <allEnvironments :time="formattedTime"></allEnvironments>
                    </div>
                    <div id="middle-zj-1">
                        <allEnvironments :time="formattedTime"></allEnvironments>
                    </div>
                </div>
                <div id="middle-bottom">
                    <realTime></realTime>
                </div>
            </section>
            <section class="screen-right">
                <div id="right-top">
                    <div id="right-top-1" style="text-align: center; font-size: 30px; line-height: 90px">
                        室外温度:{{ $globalConfig.data }}℃
                    </div>
                    <div id="right-top-2">
                        <allEnvironments1></allEnvironments1>
                    </div>
                </div>
                <div id="right-bottom">
                    <marn></marn>
                </div>
            </section>
        </div>
    </div>
</template>
<script>

import dial from "@/components/dial.vue";
import allEnvironments from "@/components/lssy.vue";
import allEnvironments2 from "@/components/allEnvironments";
import marn from "@/components/warn";
import realTime from "@/components/realTime";
import allEnvironments1 from "@/components/allEnvironments1.vue";
import axios from 'axios';
import Vue from 'vue'
export default {
    data() {
        return {
            formattedTime: null,
            sstq:null,
            timerId:null,
            timerIdw:null,
            ab:{
                show:1
            },
            ab1:{
                show:2
            },
        };
    },
    mounted() {
        this.time();
        this.startInterver();
        this.getData()
    },
    destroyed() {
        clearInterval(this.timerId);
        clearInterval(this.timerIdw);
    },
    methods: {
        time() {
            const now = new Date();
            const year = now.getFullYear();
            const month = ("0" + (now.getMonth() + 1)).slice(-2);
            const day = ("0" + now.getDate()).slice(-2);
            const hours = ("0" + now.getHours()).slice(-2);
            const minutes = ("0" + now.getMinutes()).slice(-2);
            const seconds = ("0" + now.getSeconds()).slice(-2);
            this.formattedTime =
                year +
                "年" +
                month +
                "月" +
                day +
                "日" +
                hours +
                ":" +
                minutes +
                ":" +
                seconds;
        },
        startInterver() {
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
                clearInterval(this.timerIdw);
            }
            this.timerId = setInterval(() => {
                this.time();
            }, 1000);
            this.timerIdw = setInterval(() => {
                this.getData();
            }, 3000000);
        },
        async getData() {
            // const { data: ret } = await axios.get("https://devapi.qweather.com/v7/weather/now?location=101180508&key=0ecd32942e7d44b1b935310d34d8bac3");
            // this.sstq=ret.now.temp
            // Vue.prototype.$globalConfig.data=ret.now.temp
            
        },
        
    },
    components: {
        dial,
        realTime: realTime,
        allEnvironments,
        allEnvironments2,
        marn,
        allEnvironments1,
    },
};
</script>

<style lang="less" scoped>
.screen-container {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    background-color: #161522;
    color: #fff;
    box-sizing: border-box;
}

.screen-header {
    width: 100%;
    height: 64px;
    font-size: 20px;
    position: relative;

    >div {
        img {
            width: 100%;
        }
    }

    .title {
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: 46px;
        transform: translate(-50%, -50%);
    }

    .title-right {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0px;
        top: 50px;
        transform: translateY(-80%);
    }

    .qiehuan {
        width: 28px;
        height: 21px;
        cursor: pointer;
    }

    .datetime {
        font-size: 15px;
        margin-left: 10px;
    }

    .logo {
        position: absolute;
        left: 0px;
        top: 90%;
        transform: translateY(-80%);
        img {
            height: 60px;
            width: 200px;
        }
    }
}


/* 光晕效果 */
.screen-header::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 50% 0%, rgba(0, 119, 255, 0.15), transparent 60%);
    pointer-events: none;
}

.title {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 2px;
    background: linear-gradient(45deg, #00f2fe, #00ffea);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    text-shadow: 0 0 15px rgba(0, 242, 254, 0.4);
    position: relative;
    animation: titleGlow 3s ease-in-out infinite;
}



.screen-body {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 10px;

    // .screen-left{
    //     height: 100%;
    //     width: 27.6%;
    //     #left-top{
    //         width: 100%;
    //         height: 53%;
    //     }
    //     #left-bottom{
    //         width: 100%;
    //         height: 31px;
    //         margin-top: 25px;
    //     }
    // }
    .screen-middle {
        height: 100%;
        width: 80%;
        margin-left: 1.6px;
        margin-right: 1.6px;

        #middle-top {
            width: 100%;
            height: 21.2%;
            display: flex;

            #middle-top-1 {
                display: flex;
                width: 33.3%;
                height: 100%;
                margin-left: 1.6px;
                border: 1px solid #607b8b;
            }
        }

        #middle-zj {
            width: 100%;
            height: 30%;
            margin-top: 25px;
            display: flex;

            #middle-zj-1 {
                width: 33.3%;
                height: 100%;
                border: 1px solid #607b8b;
                margin-left: 1.6px;
            }
        }

        #middle-bottom {
            margin-top: 25px;
            width: 100%;
            height: 30%;
        }
    }

    .screen-right {
        height: 100%;
        width: 27.6%;

        #right-top {
            height: 46%;

            #right-top-1 {
                height: 20%;
                border: 1px solid #607b8b;
            }

            #right-top-2 {
                height: 80%;
                border: 1px solid #607b8b;
            }
        }

        #right-bottom {
            height: 40.65%;
        }
    }
}

section>div {
    border: 1px solid #607b8b;
}
</style>